import type { ScopeRow } from "@/frontend/types/oauth";

/**
 * API scopes granted silently on every consent, with no row and no toggle.
 * `patients:read` (workspace/people visibility) is table-stakes for any client
 * and carries no privacy weight, so it is not surfaced to the user.
 */
export const ALWAYS_GRANTED_API_SCOPES = ["patients:read"] as const;

/** User-facing consent rows shared by the consent screen and the connected-apps panel. */
export const SCOPE_ROWS: ScopeRow[] = [
  {
    key: "retrieval",
    label: "Connect your healthcare facilities",
    description:
      "Search for the hospitals, clinics, and insurers you name, securely connect to them, and bring your health records into your workspace.",
    scopes: ["patient_sessions:read", "patient_sessions:write", "connections:read"],
    defaultChecked: true,
  },
  {
    key: "records",
    label: "Read your health records",
    description: "Read the health records that have been brought into your workspace.",
    scopes: ["fhir:read"],
    defaultChecked: true,
  },
  {
    key: "manage",
    label: "Manage people and delete data",
    description:
      "Add or remove people in your workspace, disconnect facilities, and delete records. Not needed for everyday use.",
    scopes: ["patients:write"],
    defaultChecked: true,
  },
];
